const ORDER_ROUTE = '/order';

const FINALIZE_ORDER_ROUTE = '/finalize-order';

const ORDER_HISTORY_ROUTE = '/orders';

const ORDERS_SUBMITTED_ROUTE = '/order-submitted';

const SUPPORT_ROUTE = '/support';

const DASHBOARD_ROUTE = '/';

const CONTACT_INFORMATION_ROUTE = '/contact-information';

const ORDER_PREFERENCES_ROUTE = '/order-preferences';

const BILLING_INFORMATION_ROUTE = '/billing-information';

const TEXT_ALERT_SETTINGS_ROUTE = '/texts';

const AUTHORIZE_ROUTE = '/authorize/callback';

const REPORT_DETAIL_ROUTE = '/orders/report/:reportId';

const SITEMPAP_ROUTE = '/sitemap';

const SITEMAP_APPROVAL_ROUTE = '/sitemap-approval';
const SITEMAP_APPROVAL_PATH_ROUTE = '/sitemap-approval/:encryptedReportId';

const SITEMAP_SUBMITTED_ROUTE = '/sitemap-submitted';
const SITEMAP_SUBMITTED_PATH_ROUTE = '/sitemap-submitted/:encryptedReportId';

const UPGRADE_ROUTE = '/orders/upgrade';

const UPGRADED_REPORT_ROUTE = '/orders/upgradedReport';

const PITCH_EDITOR_ROUTE = '/orders/pitch';

const ADDRESS_VERIFICATION_ROUTE = '/orders/identify/:reportId';

const ACCOUNT_DELETION_ROUTE = '/account-deletion';

const SERVICE_AGREEMENT_ROUTE = '/serviceagreement';

const ACH_AUTHORIZATION_ROUTE = '/ach-agreement'; // #genai

const ORDER_PREFERENCES_PRODUCT_SELECTION_ROUTE = `${ORDER_PREFERENCES_ROUTE}/product-selection`;

const ORDER_PREFERENCES_PRODUCT_SUBSTITUTIONS_ROUTE = `${ORDER_PREFERENCES_ROUTE}/substitutions`;

const ORDER_PREFERENCES_PRODUCT_ADDONS_ROUTE = `${ORDER_PREFERENCES_ROUTE}/product-add-ons`;

const ORDER_PREFERENCES_CUSTOM_COVER_PAGE_ROUTE = `${ORDER_PREFERENCES_ROUTE}/custom-cover-page`;

const ORDER_PREFERENCES_TRUDESIGN_SETTINGS_ROUTE = `${ORDER_PREFERENCES_ROUTE}/truedesign-settings`;

const ORDER_BLUEPRINT_ROUTE = '/order/blueprint';

const UPLOAD_INFORMATION_ROUTE = '/orders/blueprintinformation';

const MANAGE_PAYMENT_OPTIONS_ROUTE = '/payment-options';

const BILLING_INFORMATION_ADD_PAYMENT_METHOD_ROUTE = `${BILLING_INFORMATION_ROUTE}/add-payment-method`; // #genai
const BILLING_INFORMATION_ADD_CARD_ROUTE = `${BILLING_INFORMATION_ROUTE}/add-card`; // #genai
const BILLING_INFORMATION_ADD_ACH_ROUTE = `${BILLING_INFORMATION_ROUTE}/add-ach`; // #genai

const ANALYTICS_DASHBOARD_ROUTE = '/analytics';

const EXPORT_DATA_ROUTE = '/export-data';

const SUBMIT_PAYMENT_OPTION_ROUTE = '/payment-options/submit';

const SUBMIT_PAYMENT_OPTION_SUCCESS_ROUTE = '/payment-options/success';

const REPORT_CHANGE_ROUTE = '/reportchange';

const SERVICE_REQUEST_ROUTE = '/service-request';

const PLACE_ORDER_ROUTE = '/place-order';

const CONSUMPTION_ROUTE = '/consumption';

export {
  ORDER_ROUTE,
  FINALIZE_ORDER_ROUTE,
  ORDER_HISTORY_ROUTE,
  ORDERS_SUBMITTED_ROUTE,
  SUPPORT_ROUTE,
  DASHBOARD_ROUTE,
  CONTACT_INFORMATION_ROUTE,
  ORDER_PREFERENCES_ROUTE,
  BILLING_INFORMATION_ROUTE,
  AUTHORIZE_ROUTE,
  REPORT_DETAIL_ROUTE,
  SITEMPAP_ROUTE,
  SITEMAP_APPROVAL_ROUTE,
  SITEMAP_APPROVAL_PATH_ROUTE,
  SITEMAP_SUBMITTED_ROUTE,
  SITEMAP_SUBMITTED_PATH_ROUTE,
  UPGRADE_ROUTE,
  UPGRADED_REPORT_ROUTE,
  PITCH_EDITOR_ROUTE,
  TEXT_ALERT_SETTINGS_ROUTE,
  SERVICE_AGREEMENT_ROUTE,
  ACH_AUTHORIZATION_ROUTE,
  ADDRESS_VERIFICATION_ROUTE,
  ACCOUNT_DELETION_ROUTE,
  ORDER_PREFERENCES_PRODUCT_SELECTION_ROUTE,
  ORDER_PREFERENCES_PRODUCT_SUBSTITUTIONS_ROUTE,
  ORDER_PREFERENCES_PRODUCT_ADDONS_ROUTE,
  ORDER_PREFERENCES_CUSTOM_COVER_PAGE_ROUTE,
  ORDER_PREFERENCES_TRUDESIGN_SETTINGS_ROUTE,
  ORDER_BLUEPRINT_ROUTE,
  UPLOAD_INFORMATION_ROUTE,
  MANAGE_PAYMENT_OPTIONS_ROUTE,
  ANALYTICS_DASHBOARD_ROUTE,
  SUBMIT_PAYMENT_OPTION_ROUTE,
  SUBMIT_PAYMENT_OPTION_SUCCESS_ROUTE,
  REPORT_CHANGE_ROUTE,
  EXPORT_DATA_ROUTE,
  SERVICE_REQUEST_ROUTE,
  PLACE_ORDER_ROUTE,
  CONSUMPTION_ROUTE,
  // #genai Phase 2 add-payment-method routes
  BILLING_INFORMATION_ADD_PAYMENT_METHOD_ROUTE,
  BILLING_INFORMATION_ADD_CARD_ROUTE,
  BILLING_INFORMATION_ADD_ACH_ROUTE,
};
